import type React from 'react';
import { useTranslation } from 'react-i18next';

interface PartnerSeoBioProps {
  biography: string;
}

const PartnerSeoBio: React.FC<PartnerSeoBioProps> = ({ biography }) => {
  const { t } = useTranslation();

  return (
    <div className="flex min-w-full flex-col items-start justify-start p-2">
      <div className="min-w-full">
        <span className="my-4 line-clamp-1 flex min-w-full flex-row items-center justify-between overflow-hidden text-ellipsis break-all">
          <span className="line-clamp-1 grow overflow-hidden text-ellipsis break-all text-xl font-bold">
            {t('static.profile_page.biography_section_label')}
          </span>
        </span>
        <div className="min-w-full text-pretty text-sm">
          <p className="mt-2">{biography}</p>
        </div>
      </div>
    </div>
  );
};

export default PartnerSeoBio;
